var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.33325 6.4165H4.66659C4.51188 6.4165 4.3635 6.35505 4.25411 6.24565C4.14471 6.13625 4.08325 5.98788 4.08325 5.83317V4.08317C4.08325 3.30962 4.39054 2.56776 4.93752 2.02078C5.4845 1.47379 6.22637 1.1665 6.99992 1.1665C7.77347 1.1665 8.51533 1.47379 9.06231 2.02078C9.60929 2.56776 9.91658 3.30962 9.91658 4.08317V5.83317C9.91658 5.98788 9.85513 6.13625 9.74573 6.24565C9.63633 6.35505 9.48796 6.4165 9.33325 6.4165ZM5.24992 5.24984H8.74992V4.08317C8.74992 3.61904 8.56554 3.17392 8.23736 2.84573C7.90917 2.51755 7.46405 2.33317 6.99992 2.33317C6.53579 2.33317 6.09067 2.51755 5.76248 2.84573C5.43429 3.17392 5.24992 3.61904 5.24992 4.08317V5.24984Z",
    fill: "#171725"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91658 5.25H4.08325C3.11675 5.25 2.33325 6.0335 2.33325 7V11.0833C2.33325 12.0498 3.11675 12.8333 4.08325 12.8333H9.91658C10.8831 12.8333 11.6666 12.0498 11.6666 11.0833V7C11.6666 6.0335 10.8831 5.25 9.91658 5.25Z",
    fill: "#171725"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2d85b80d3ed860406569eaaedbf8839b.svg";
export { ForwardRef as ReactComponent };